export default {"src":"/uk/_next/static/media/spot-verify-identity.ef170f5e.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};